export function enabledInteractions(hotspot) {
  return (hotspot.interactions || []).filter(interaction => interaction.enabled !== false);
}

export function effectiveInteractionPoints(hotspot, interaction) {
  return {
    walkTo: interaction.walkTo || hotspot.walkTo || null,
    faceTo: interaction.faceTo || hotspot.faceTo || null
  };
}

export function runInteraction({ controller, hotspot, interaction, operation = null, dispatch = () => {}, reject = () => {}, complete = () => {} }) {
  const { walkTo, faceTo } = effectiveInteractionPoints(hotspot, interaction);
  const alive=()=>!operation?.signal.aborted,guard=(callback,step)=>operation?.guard?operation.guard(callback,step):callback;
  operation?.onAbort(()=>controller.cancel());
  const finish = () => {
    if(!alive())return;
    if (interaction.requiresFaceTo && faceTo) {
      operation?.setStep("faceTo");
      if (typeof controller.faceTo === "function") return controller.faceTo(faceTo, guard(performAction,"faceTo-completion"));
      controller.facing = faceTo.x < controller.position.x ? "left" : "right"; controller.onChange(controller);
    }
    performAction();
  };
  const performAction = () => {if(!alive())return;operation?.setStep("action");if (interaction.action?.type !== "walk-only")Promise.resolve(dispatch(interaction.action || { type: "none" }, interaction, hotspot,operation)).finally(complete);else complete(); };
  if (interaction.requiresWalkTo) {
    if (!walkTo) { reject("This interaction requires Walk-to, but no point is configured.");complete(); return false; }
    operation?.setStep("walkTo");
    if (!controller.walkTo(walkTo, guard(finish,"walkTo-completion"))) { reject("The interaction Walk-to point is unreachable.");complete(); return false; }
    return true;
  }
  finish();
  return true;
}

export class InteractionMenu {
  constructor({ onChoose, onClose = () => {}, onOpen = () => {} }) {
    this.onChoose = onChoose; this.onClose = onClose; this.onOpen = onOpen;
    this.element = document.createElement("div");
    this.element.className = "interaction-menu";
    this.element.setAttribute("role", "menu");
    this.element.hidden = true;
    document.body.append(this.element);
    this.onDocumentPointer = event => { if (!this.element.hidden && !this.element.contains(event.target)) this.close(); };
    this.onDocumentKey = event => {
      if (this.element.hidden) return;
      const items = [...this.element.querySelectorAll('[role="menuitem"]')], index = items.indexOf(document.activeElement);
      if (event.key === "Escape") { event.preventDefault(); this.close(); }
      else if (event.key === "ArrowDown") { event.preventDefault(); items[(index + 1 + items.length) % items.length]?.focus(); }
      else if (event.key === "ArrowUp") { event.preventDefault(); items[(index - 1 + items.length) % items.length]?.focus(); }
      else if (event.key === "Home") { event.preventDefault(); items[0]?.focus(); }
      else if (event.key === "End") { event.preventDefault(); items.at(-1)?.focus(); }
    };
    document.addEventListener("pointerdown", this.onDocumentPointer, true);
    document.addEventListener("keydown", this.onDocumentKey);
  }
  open(interactions, clientPoint, hotspot) {
    this.hotspot = hotspot;
    this.element.replaceChildren(...interactions.map(interaction => {
      const button = document.createElement("button");
      button.type = "button"; button.className = "interaction-menu__item"; button.setAttribute("role", "menuitem");
      button.dataset.interactionId = interaction.id;button.dataset.icon=iconForVerb(interaction.verb);
      if(interaction.id===hotspot.defaultInteraction){button.classList.add("interaction-menu__item--default");button.dataset.default="true"}
      button.setAttribute("aria-label",`${interaction.label||interaction.verb||"Custom action"} — ${hotspot.label||hotspot.id}`);
      button.append(createInteractionIcon(iconForVerb(interaction.verb)));
      const label=document.createElement("span");label.className="interaction-menu__label";label.textContent=interaction.label||interaction.verb||"Custom";button.append(label);
      button.addEventListener("click", () => { this.close(); this.onChoose(interaction, hotspot); });
      return button;
    }));
    this.element.hidden = false;this.onOpen(interactions,hotspot); this.element.style.left = "0px"; this.element.style.top = "0px";
    const rect = this.element.getBoundingClientRect(), margin = 8;
    const left = Math.max(margin, Math.min(innerWidth - rect.width - margin, clientPoint.x));
    const top = Math.max(margin, Math.min(innerHeight - rect.height - margin, clientPoint.y));
    this.element.style.left = `${left}px`; this.element.style.top = `${top}px`;
    this.element.querySelector("button")?.focus();
  }
  close() {
    if (this.element.hidden) return;
    this.element.hidden = true; this.element.replaceChildren(); this.onClose();
  }
  dispose() {
    this.close(); document.removeEventListener("pointerdown", this.onDocumentPointer, true);
    document.removeEventListener("keydown", this.onDocumentKey); this.element.remove();
  }
}

export function ensureInteractionMenuStyles() {
  ensureInteractionIconStyles();
  if (document.querySelector("#interaction-menu-styles")) return;
  const style = document.createElement("style"); style.id = "interaction-menu-styles";
  style.textContent = `.interaction-menu{position:fixed;z-index:2200;min-width:165px;padding:5px;border:1px solid #557383;border-radius:5px;background:#071018f5;box-shadow:0 8px 28px #000b}.interaction-menu[hidden]{display:none}.interaction-menu__item{position:relative;display:flex;align-items:center;gap:9px;width:100%;padding:8px 11px;border:0;border-radius:3px;background:transparent;color:#e8f7fb;text-align:left;white-space:nowrap}.interaction-menu__item:hover,.interaction-menu__item:focus{outline:none;background:#17455b;color:#fff}.interaction-menu__item--default:after{content:"";position:absolute;right:7px;width:4px;height:4px;border-radius:50%;background:#73d6fa}.interaction-menu__label{padding-right:10px;pointer-events:none}@media(pointer:coarse){.interaction-menu__item{min-height:44px;padding:10px 12px}}`;
  style.textContent += `.interaction-menu{cursor:default}.interaction-menu__item{cursor:pointer}`;
  document.head.append(style);
}
import { createInteractionIcon, ensureInteractionIconStyles, iconForVerb } from "./interaction-icons.js";
